import axios from 'axios';
// import { toast } from 'react-toastify';
// import { useSelector } from 'react-redux';



class Apis {

    // static host = 'http://localhost:8080';
    static host = 'https://app.caleivent.com';
    static httpClient = axios.create({
        baseURL: this.host,
        validateStatus: false,
    });


    static getAuthHeaders() {
        return {
            "session-token": window.localStorage.getItem('sessionToken'),
        };
    }

    static postProcessResponse(promise) {
        return new Promise((resolve, reject) => {
            promise.then(resolve).catch(reject);
        }).then((res) => {
            let data = res.data;
            if (data.success === true) {
                return data.data;
            } else {
                throw res;
            }
        }).catch((err) => {
            // Handle axios network errors
            if (err.message && !err.data) {
                throw new AppError({
                    message: err.message,
                    code: 'NETWORK_ERROR',
                });
            }
            // Handle API error responses
            if (err && err.data && typeof err.data.message === "string") {
                throw new AppError({
                    message: err.data.message,
                    code: err.data.code || 'API_ERROR',
                });
            } else if (err && err.data && err.data.error) {
                // Handle error object in data.error
                throw new AppError({
                    message: typeof err.data.error === 'string' ? err.data.error : 'An error occurred',
                    code: err.data.code || 'API_ERROR',
                });
            } else if (typeof err === "string") {
                throw AppError.from(err);
            } else {
                // Log the full error for debugging
                console.error('Unhandled API error:', err);
                throw new AppError({
                    message: "Something went wrong!",
                    code: 'UNKNOWN_ERROR',
                });
            }
        });
    }

    static post(url, data, headers = {}) {
        return this.postProcessResponse(this.httpClient.post(url, data, {
            headers: {
                ...this.getAuthHeaders(),
                ...headers,
            }
        }));
    }

    static put(url, data, headers = {}) {
        return this.postProcessResponse(this.httpClient.put(url, data, {
            headers: {
                ...this.getAuthHeaders(),
                ...headers,
            }
        }));
    }

    static get(url, config = {}) {
        return this.postProcessResponse(this.httpClient.get(url, {
            headers: this.getAuthHeaders(),
            ...config
        }));
    }

    static delete(url) {
        return this.postProcessResponse(this.httpClient.delete(url, { headers: this.getAuthHeaders() }));
    }


    // static errorToast(err) {
    //     let message = err + "";
    //     if (err.message) {
    //         message = err.message;
    //     }
    //     toast(message, { type: 'error', theme: 'dark', autoClose: 2500 });
    // }

    // static successToast(msg) {
    //     toast(msg, { type: 'success', theme: 'dark', autoClose: 2500 });
    // }


    // static showLoader() {
    //     Swal.fire({
    //         showCloseButton: false,
    //         timerProgressBar: true,
    //         allowOutsideClick: false,
    //         didOpen: () => {
    //             Swal.showLoading();
    //         },
    //     });
    // }


    // static hideLoader() {
    //     Swal.close();
    // }



}

class ApiState {

    constructor({
        isLoading,
        error,
        data,
        isInitialized,
        updatedAt,
    }) {
        this.isLoading = isLoading === undefined ? false : isLoading;
        this.error = error === undefined ? false : error;
        this.data = data;
        this.isInitialized = isInitialized === undefined ? false : isInitialized;
        this.updatedAt = updatedAt === undefined ? new Date() : updatedAt;
    }

    static init() {
        return this.fromOb(null);
    }

    static fromOb(ob) {
        if (ob === undefined || ob === null) {
            return new ApiState({
                isLoading: false,
                error: null,
                data: null,
                isInitialized: false,
                updatedAt: (new Date()).toISOString(),
            });
        }
        return new ApiState({
            ...ob
        });
    }


    toLoading() {
        return new ApiState({
            isLoading: true,
            error: null,
            data: this.data,
            isInitialized: this.isInitialized,
            updatedAt: this.updatedAt,
        });
    }

    toComplete(data) {
        return new ApiState({
            isLoading: false,
            error: null,
            data: data,
            isInitialized: true,
            updatedAt: (new Date()).toISOString(),
        });
    }

    toError(error) {
        return new ApiState({
            isLoading: false,
            error: error + "",
            data: this.data,
            isInitialized: this.isInitialized,
            updatedAt: (new Date()).toISOString(),
        });
    }


    toOb() {
        return {
            isLoading: this.isLoading,
            error: this.error,
            data: this.data,
            isInitialized: this.isInitialized,
            updatedAt: this.updatedAt,
        };
    }


}

class AppError extends Error {



    constructor({ message, code }) {
        super(message);
        this.message = message;
        this.code = code;
    }

    static from(error) {
        if (error instanceof AppError) {
            return new AppError({
                message: this.message,
                code: this.code,
            });
        } else if (error instanceof Error) {
            return new AppError({
                message: error.message,
                code: error.name,
            });
        } else {
            return new AppError({
                code: 'UNKNOWN',
                message: `${error}`,
            })
        }
    }


    toString() {
        return this.message;
    }
}

export { Apis, ApiState };